import React, { useEffect, useState } from "react";
import api from "../../api/axios";

const SoldUnitByMonth = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  //  month & year filter
  const [filters, setFilters] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  });

  //  fetch report data
  const fetchReport = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        "/api/reports/sold-units-month-wise",
        { params: filters }
      );

      setData(res.data.data || []);
    } catch (error) {
      console.error("Failed to load sold unit report", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  //  PDF download
  const downloadPDF = async () => {
    try {
      const res = await api.get(
        "/api/reports/sold-units-month-wise-pdf",
        {
          params: filters,
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `sold-units-${filters.month}-${filters.year}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("PDF download failed", err);
    }
  };

  // 🔹 CSV download (client-side)
  const downloadCSV = () => {
    let csv = "SL,Unit No,Type,Area,Price,Sold Date\n";

    data.forEach((unit, index) => {
      csv += `${index + 1},${unit.unit_number},${unit.type?.name || ""
        },${unit.property?.location?.area || ""
        },${unit.price},${unit.updated_at}\n`;
    });

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "sold-units-month-wise.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">
        Sold Unit Report (Month Wise)
      </h4>

      {/* 🔹 Filter Section */}
      <div className="row mb-3">
        <div className="col-md-3">
          <label className="form-label">Month</label>
          <select
            className="form-select"
            value={filters.month}
            onChange={(e) =>
              setFilters({ ...filters, month: e.target.value })
            }
          >
            {[...Array(12)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {new Date(0, i).toLocaleString("default", {
                  month: "long",
                })}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label className="form-label">Year</label>
          <input
            type="number"
            className="form-control"
            value={filters.year}
            onChange={(e) =>
              setFilters({ ...filters, year: e.target.value })
            }
          />
        </div>

        <div className="col-md-3 d-flex align-items-end">
          <button className="btn btn-primary w-100" onClick={fetchReport}>
            Search
          </button>
        </div>
      </div>

      {/* 🔹 Data Table */}
      <div className="card shadow-sm">
        <div className="card-body">
          <table className="table table-bordered text-center">
            <thead className="table-light">
              <tr>
                <th>SL</th>
                <th>Unit No</th>
                <th>Type</th>
                <th>Area</th>
                <th>Price</th>
                <th>Sold Date</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6">Loading...</td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan="6">No sold data found</td>
                </tr>
              ) : (
                data.map((unit, index) => (
                  <tr key={unit.id}>
                    <td>{index + 1}</td>
                    <td>{unit.unit_number}</td>
                    <td>{unit.type?.name}</td>
                    <td>{unit.property?.location?.area}</td>
                    <td className="fw-bold">
                      {Number(unit.price).toLocaleString()}
                    </td>
                    <td>
                      {new Date(unit.updated_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/*  Action Buttons */}
          <div className="text-end">
            <button
              className="btn btn-danger"
              onClick={downloadPDF}
            >
              PDF Download
            </button>
            <button
              className="btn btn-secondary ms-2"
              onClick={downloadCSV}
            >
              CSV Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoldUnitByMonth;
